export default function modalSpinner(selector, event){
    if(event === 'start'){
        $(selector).find( ".rd-btn_spinner" ).addClass("loading-start").attr("disabled",true);
    }else{
        $(selector).find( ".rd-btn_spinner" ).removeClass("loading-start").removeAttr("disabled");
    }
}